module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SitePage_Gallery

(function (fox, $) {
	
	fox.registerWidget('SitePage_Gallery', {}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/gallery.js
// module id = 900
// module chunks = 4